module.exports = __webpack_public_path__ + "img/82-X-Brush Schwarzbraun - Gris Métal Fonc‚.jpg";